import { h } from 'preact';
import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { MessageTimestamp, formatTimestamp } from '@oracle/oraclejet-preact/UNSAFE_Message';

const todaysDate = new Date();
const pastDate = new Date(todaysDate);
pastDate.setUTCFullYear(2020);

describe('Test MessageTimestamp component', () => {
  it("today's date", async function () {
    const isoString = todaysDate.toISOString();
    const content = render(
      <MessageTimestamp
        value={isoString}
      />
    );

    const text = formatTimestamp(isoString);
    const timestamp = await content.findByText(text);
    expect(timestamp).not.null;
  });

  it("past date", async function () {
    const isoString = pastDate.toISOString();
    const content = render(
      <MessageTimestamp
        value={isoString}
      />
    );

    const text = formatTimestamp(isoString);
    const timestamp = await content.findByText(text);
    expect(timestamp).not.null;
  });
});
